import { useQuery } from '@tanstack/react-query'
import { socialApi } from '../api/social.api'
import type { LeaderboardScope } from '../types'

export const LEADERBOARD_KEY = ['social', 'leaderboard'] as const

export function useLeaderboard(scope: LeaderboardScope) {
  return useQuery({
    queryKey: [...LEADERBOARD_KEY, scope],
    queryFn: () => socialApi.fetchLeaderboard(scope).then((r) => r.data.data),
    staleTime: 60_000,
  })
}
